/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import * as React from 'react';
const OuiIconLogoApache = ({ title, titleId, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <linearGradient
        id="logo_apache-a"
        x1="21.902%"
        x2="141.879%"
        y1="63.905%"
        y2="20.213%">
        <stop offset="0%" stopColor="#F69923" />
        <stop offset="31.23%" stopColor="#F79A23" />
        <stop offset="83.83%" stopColor="#E97826" />
      </linearGradient>
      <linearGradient
        id="logo_apache-b"
        x1="-217.651%"
        x2="74.743%"
        y1="177.127%"
        y2="36.665%">
        <stop offset="32.33%" stopColor="#9E2064" />
        <stop offset="63.02%" stopColor="#C92037" />
        <stop offset="75.14%" stopColor="#CD2335" />
        <stop offset="100%" stopColor="#E97826" />
      </linearGradient>
      <linearGradient
        id="logo_apache-c"
        x1="-80.044%"
        x2="146.24%"
        y1="73.574%"
        y2="31.539%">
        <stop offset="32.33%" stopColor="#9E2064" />
        <stop offset="63.02%" stopColor="#C92037" />
        <stop offset="75.14%" stopColor="#CD2335" />
        <stop offset="100%" stopColor="#E97826" />
      </linearGradient>
      <linearGradient
        id="logo_apache-d"
        x1="-18.316%"
        x2="165.002%"
        y1="52.497%"
        y2="41.656%">
        <stop offset="0%" stopColor="#282662" />
        <stop offset="9.548%" stopColor="#662E8D" />
        <stop offset="78.82%" stopColor="#9F2064" />
        <stop offset="94.87%" stopColor="#CD2032" />
      </linearGradient>
      <linearGradient
        id="logo_apache-e"
        x1="-109.701%"
        x2="64.617%"
        y1="463.715%"
        y2="17.19%">
        <stop offset="32.33%" stopColor="#9E2064" />
        <stop offset="63.02%" stopColor="#C92037" />
        <stop offset="75.14%" stopColor="#CD2335" />
        <stop offset="100%" stopColor="#E97826" />
      </linearGradient>
      <linearGradient
        id="logo_apache-f"
        x1="-34.88%"
        x2="110.599%"
        y1="130.522%"
        y2="-9.118%">
        <stop offset="32.33%" stopColor="#9E2064" />
        <stop offset="63.02%" stopColor="#C92037" />
        <stop offset="75.14%" stopColor="#CD2335" />
        <stop offset="100%" stopColor="#E97826" />
      </linearGradient>
      <linearGradient
        id="logo_apache-g"
        x1="-13.673%"
        x2="117.858%"
        y1="192.564%"
        y2="-136.906%">
        <stop offset="0%" stopColor="#282662" />
        <stop offset="9.548%" stopColor="#662E8D" />
        <stop offset="78.82%" stopColor="#9F2064" />
        <stop offset="94.87%" stopColor="#CD2032" />
      </linearGradient>
    </defs>
    <g fill="none">
      <path
        fill="url(#logo_apache-a)"
        d="M13.628.18c-.498.293-1.332 1.134-2.328 2.348v.074l.871 1.613.044.03c.641-.914 1.289-1.742 1.948-2.446.05-.056.075-.08.075-.08-.025.024-.05.055-.075.08-.211.237-.859.984-1.83 2.478l.112.025s2.273-.224 3.368-.41l.062-.057c.35-1.955-.342-2.851-.342-2.851S14.661-.423 13.628.18Z"
        transform="translate(8)"
      />
      <path
        fill="url(#logo_apache-b)"
        d="M9.525 8.697c.28-.516.56-1.027.84-1.519.293-.51.592-1.008.897-1.488a.397.397 0 0 0 .05-.087c.299-.473.598-.921.903-1.357L11.3 2.52c-.069.081-.137.168-.206.256-.261.33-.535.678-.815 1.052a51.783 51.783 0 0 0-1.893 2.708c-.261.405-.53.816-.79 1.245l-.032.05V7.9l1.14 2.26.05.019c.255-.498.51-.996.771-1.482Z"
        transform="translate(8)"
      />
      <path
        fill="url(#logo_apache-c)"
        d="M4.563 19.76c.206-.535.424-1.077.642-1.625.211-.523.423-1.052.647-1.58.218-.53.448-1.06.679-1.595.236-.541.473-1.083.716-1.618.242-.53.485-1.059.734-1.582.087-.186.18-.38.274-.566.156-.324.318-.648.473-.965.007-.019.02-.031.025-.05L7.564 7.832l-.056.093c-.274.455-.554.915-.822 1.389a54.535 54.535 0 0 0-1.45 2.714c-.044.087-.081.168-.125.255a32.15 32.15 0 0 0-.703 1.544c-.237.56-.448 1.096-.635 1.606-.125.337-.23.654-.336.965-.081.262-.162.53-.237.791-.18.623-.33 1.239-.454 1.862l.018.074 1.14 2.266.037.02c.155-.424.317-.848.485-1.283.044-.125.094-.243.137-.368Z"
        transform="translate(8)"
      />
      <path
        fill="url(#logo_apache-d)"
        d="M2.733 19.132a18.84 18.84 0 0 0-.311 2.253c0 .025-.006.05-.006.081-.374-.598-1.37-1.177-1.37-1.177.716 1.034 1.258 2.061 1.338 3.07-.38.08-.902-.038-1.512-.255.628.578 1.102.74 1.288.784-.579.037-1.183.436-1.793.89.89-.36 1.607-.504 2.123-.392-.815 2.31-1.63 4.862-2.453 7.564.25-.075.399-.243.486-.473.143-.492 1.114-3.704 2.627-7.931.044-.119.087-.243.13-.362.013-.03.026-.068.038-.1.162-.441.324-.896.498-1.356.038-.106.081-.212.119-.318v-.006l-1.19-2.353c0 .03-.006.056-.012.08Z"
        transform="translate(8)"
      />
      <path
        fill="url(#logo_apache-e)"
        d="M12.333 4.283c-.268.411-.56.878-.878 1.407-.018.025-.03.056-.05.081a62.538 62.538 0 0 0-1.687 3.05c-.249.48-.504.984-.765 1.526l.056.025 2.895-.311.068-.05c.878-.405 1.27-.772 1.65-1.301.1-.143.205-.3.305-.455.311-.485.616-1.015.884-1.544.261-.51.492-1.02.672-1.475a6.56 6.56 0 0 0 .398-1.395c-1.17.206-2.608.399-3.548.442Z"
        transform="translate(8)"
      />
      <path
        fill="url(#logo_apache-f)"
        d="M8.84 10.59c-.1.212-.205.43-.31.647-.113.237-.231.486-.343.735-.056.124-.119.255-.175.38-.18.386-.354.784-.541 1.195a107.035 107.035 0 0 0-1.357 3.194c-.218.529-.436 1.077-.654 1.637-.2.504-.399 1.015-.598 1.55-.012.025-.018.05-.03.075-.2.53-.394 1.068-.6 1.622-.006.012-.017.045-.023.057l.043.01.866-.094.048-.02c-.018-.006-.03-.03-.048-.037 1.145-.143 2.67-1.002 3.66-2.06.455-.486.866-1.065 1.252-1.738.286-.504.547-1.058.803-1.675.224-.535.435-1.12.64-1.749a3.457 3.457 0 0 1-.896.311 8.977 8.977 0 0 1-.18.038c-.062.012-.125.018-.18.03 1.07-.41 1.743-1.207 2.234-2.178-.28.193-.74.442-1.288.566a2.52 2.52 0 0 1-.23.044c-.02 0-.038.006-.057.006.374-.155.685-.33.959-.535.056-.044.112-.087.168-.137.081-.075.162-.15.237-.224.05-.05.093-.1.143-.156.106-.124.205-.261.299-.41.03-.044.056-.094.087-.138.037-.068.068-.137.1-.205.149-.3.267-.567.36-.803.05-.119.088-.224.125-.33.013-.038.025-.081.044-.119.037-.112.068-.211.093-.305.037-.13.056-.236.069-.311a1.077 1.077 0 0 1-.125.087c-.324.193-.878.368-1.326.448l.884-.1-.884.1c-.062.013-.106.02-.156.032.004-.005-.994.101-2.995.316a2.313 2.313 0 0 0-.118.244Z"
        transform="translate(8)"
      />
      <path
        fill="url(#logo_apache-g)"
        d="M4.115 21.914c-.155.43-.317.872-.473 1.32 0 .006-.006.013-.006.019-.025.062-.044.124-.069.193-.106.305-.199.573-.41 1.195.348.162.628.58.896 1.059a1.876 1.876 0 0 0-.623-1.314c1.725.075 3.213-.361 3.979-1.619.068-.112.13-.23.186-.355-.348.442-.784.63-1.593.586h-.007.007c1.201-.536 1.799-1.052 2.334-1.905.125-.206.25-.424.374-.667-1.052 1.078-2.266 1.383-3.543 1.152l-.958.106c-.032.069-.063.15-.094.23Z"
        transform="translate(8)"
      />
    </g>
  </svg>
);
export const icon = OuiIconLogoApache;
